/* Cedar native carousels — takes over the app/Splide sliders whose own JS we don't ship.
   The source uses Splide (testimonials) and Vitals (instagram feed). We froze the HYDRATED DOM,
   so their markup is present but half-transformed and no library re-inits it → everything stacks.
   This rebuilds the behaviour natively: horizontal scroll-snap track + real dots + arrows.
   Runs on DOMContentLoaded and is idempotent (guards with data-cedar-carousel). */
(function () {
  function build(track, opts) {
    if (!track || track.dataset.cedarCarousel) return;
    var slides = opts.slides(track);
    if (!slides.length) return;
    track.dataset.cedarCarousel = '1';

    // scroll-snap strip
    track.style.display = 'flex';
    track.style.flexWrap = 'nowrap';
    track.style.overflowX = 'auto';
    track.style.scrollSnapType = 'x mandatory';
    track.style.gap = opts.gap || '14px';
    track.style.scrollBehavior = 'smooth';
    track.style.webkitOverflowScrolling = 'touch';
    track.style.scrollbarWidth = 'none';
    track.style.padding = opts.pad || '0';
    var hide = document.createElement('style');
    hide.textContent = '[data-cedar-carousel]::-webkit-scrollbar{display:none}';
    if (!document.getElementById('cedar-carousel-css')) { hide.id = 'cedar-carousel-css'; document.head.appendChild(hide); }

    slides.forEach(function (s) {
      s.style.flex = '0 0 ' + (opts.basis || '86%');
      s.style.scrollSnapAlign = 'center';
      s.style.maxWidth = opts.max || '520px';
      s.style.margin = '0';
      s.style.transform = 'none';   // clear any leftover Splide inline transform
    });

    // container to host dots/arrows
    var host = track.parentElement;
    host.style.position = host.style.position || 'relative';

    // dots
    var dots = document.createElement('div');
    dots.style.cssText = 'display:flex;justify-content:center;gap:8px;margin:16px 0 4px;flex-wrap:wrap';
    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      d.style.cssText = 'width:9px;height:9px;border-radius:50%;border:0;padding:0;cursor:pointer;background:#d9d9d9;transition:background .2s,transform .2s';
      d.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dots.appendChild(d);
    });
    host.appendChild(dots);

    function sync() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2 - track.offsetLeft;
        var dd = Math.abs(c - mid);
        if (dd < bestD) { bestD = dd; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.style.background = i === best ? (opts.active || '#e11d48') : '#d9d9d9';
        d.style.transform = i === best ? 'scale(1.25)' : 'none';
      });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
    sync();

    // arrows (reuse the source's if present, else make them)
    function go(dir) {
      var w = slides[0].offsetWidth + 14;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    var prev = opts.prev && host.querySelector(opts.prev);
    var next = opts.next && host.querySelector(opts.next);
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
  }

  function buildReview(root) {
    if (!root || root.dataset.cedarReviewCarousel) return;

    // The copied Splide markup is upgraded by the theme's bundled Splide
    // component before this file runs. Isolate the review markup in a plain
    // shell so its drag handlers cannot cancel native finger scrolling.
    var component = root.closest('splide-component');
    if (component && !component.dataset.cedarReviewIsolated) {
      var shell = document.createElement('div');
      Array.prototype.forEach.call(component.attributes, function (attr) {
        shell.setAttribute(attr.name, attr.value);
      });
      shell.dataset.cedarReviewIsolated = '1';
      shell.style.display = 'block';
      shell.innerHTML = component.innerHTML;
      component.replaceWith(shell);
      root = shell.querySelector('.splide');
      if (!root) return;
    }

    var list = root.querySelector('.splide__list');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('.splide__slide:not(.is-clone)'));
    if (!slides.length) return;

    root.dataset.cedarReviewCarousel = '1';
    list.querySelectorAll('.splide__slide.is-clone').forEach(function (clone) { clone.remove(); });
    root.querySelectorAll('.splide__pagination, .splide__arrows').forEach(function (controls) {
      controls.remove();
    });

    var track = list.parentElement;
    var dotsHost = root.querySelector('.splide__dots-and-arrows') || root;
    root.classList.remove('splide--draggable', 'is-initialized', 'is-active', 'is-overflow');
    if (track) track.classList.remove('splide__track--draggable');
    list.removeAttribute('style');
    list.style.display = 'flex';
    list.style.flexWrap = 'nowrap';
    list.style.alignItems = 'stretch';
    list.style.width = '100%';
    list.style.height = 'auto';
    list.style.overflowX = 'auto';
    list.style.overflowY = 'hidden';
    list.style.scrollSnapType = 'x mandatory';
    list.style.scrollBehavior = 'smooth';
    list.style.webkitOverflowScrolling = 'touch';
    list.style.scrollbarWidth = 'none';
    list.style.touchAction = 'auto';
    list.style.transform = 'none';
    if (track) {
      track.style.overflow = 'visible';
      track.style.height = 'auto';
      track.style.touchAction = 'auto';
    }

    slides.forEach(function (slide) {
      slide.style.flex = '0 0 100%';
      slide.style.width = '100%';
      slide.style.maxWidth = 'none';
      slide.style.margin = '0';
      slide.style.scrollSnapAlign = 'start';
      slide.style.transform = 'none';
      slide.removeAttribute('aria-hidden');
    });

    var dots = document.createElement('div');
    dots.className = 'cedar-review-dots';
    dots.style.cssText = 'display:flex;justify-content:center;gap:8px;margin:12px 0 4px;flex-wrap:wrap';
    slides.forEach(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
      dot.style.cssText = 'width:9px;height:9px;border-radius:50%;border:0;padding:0;cursor:pointer;background:#d9d9d9;transition:background .2s,transform .2s';
      dot.addEventListener('click', function () {
        list.scrollTo({ left: index * list.clientWidth, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });
    dotsHost.appendChild(dots);

    function sync() {
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(list.scrollLeft / Math.max(1, list.clientWidth))));
      Array.prototype.forEach.call(dots.children, function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.style.background = active ? '#000' : '#d9d9d9';
        dot.style.transform = active ? 'scale(1.25)' : 'none';
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    list.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  function buildTestimonials(root) {
    if (!root || root.dataset.cedarTestimonials) return;
    var component = root.closest('splide-component');
    if (component && !component.dataset.cedarTestimonialsIsolated) {
      var shell = document.createElement('div');
      Array.prototype.forEach.call(component.attributes, function (attr) { shell.setAttribute(attr.name, attr.value); });
      shell.dataset.cedarTestimonialsIsolated = '1';
      shell.innerHTML = component.innerHTML;
      component.replaceWith(shell);
      root = shell.querySelector('#splide02');
      if (!root) return;
    }
    var list = root.querySelector('.splide__list');
    var slides = list && Array.prototype.slice.call(list.querySelectorAll('.splide__slide:not(.is-clone):not(.splide__slide--clone)'));
    if (!list || !slides || slides.length !== 6) return;
    root.dataset.cedarTestimonials = '1';
    list.querySelectorAll('.is-clone, .splide__slide--clone').forEach(function (node) { node.remove(); });
    var track = list.parentElement;
    var controls = root.querySelector('.splide__dots-and-arrows') || root;
    controls.innerHTML = '';
    root.classList.remove('splide--draggable', 'is-initialized', 'is-active', 'is-overflow');
    if (track) track.classList.remove('splide__track--draggable');
    list.removeAttribute('style');
    list.style.cssText = 'display:flex;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none;touch-action:auto;width:100%;gap:15px';
    var css = document.createElement('style');
    css.textContent = '#splide02-list::-webkit-scrollbar{display:none}#splide02-list .splide__slide{flex:0 0 100%!important;width:100%!important;margin:0!important;scroll-snap-align:start;transform:none}#splide02-controls{display:flex!important;align-items:center;justify-content:center;gap:18px;margin-top:18px;position:static!important;pointer-events:auto!important}#splide02-controls .splide__arrows{display:contents}#splide02-controls .splide__arrow{position:static;transform:none;opacity:1;background:none;padding:0;width:28px;height:28px;pointer-events:auto!important;cursor:pointer}#splide02-controls .splide__arrow svg{width:20px;height:20px}#splide02-controls .splide__pagination{display:flex!important;position:static!important;gap:8px;align-items:center;justify-content:center;list-style:none;margin:0;padding:0;width:auto;pointer-events:auto!important}#splide02-controls .splide__pagination__page{width:9px;height:9px;border-radius:50%;border:0;background:#d9d9d9;padding:0;pointer-events:auto!important;cursor:pointer}#splide02-controls .splide__pagination__page.is-active{background:#000;transform:scale(1.25)}@media(min-width:750px){#splide02-list{gap:40px!important}#splide02-list .splide__slide{flex-basis:calc((100% - 80px)/3)!important;width:calc((100% - 80px)/3)!important;margin-right:0!important}#splide02-controls .splide__pagination__page:nth-child(n+5){display:none!important}}';
    document.head.appendChild(css);
    slides.forEach(function (slide) { slide.style.cssText = 'margin:0;scroll-snap-align:start;transform:none'; slide.removeAttribute('aria-hidden'); });
    controls.id = 'splide02-controls';
    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'splide__arrow splide__arrow--prev'; prev.setAttribute('aria-label', 'Previous testimonial'); prev.innerHTML = '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="m24.5 0.932 4.3 4.38-14.5 14.6 14.5 14.5-4.3 4.4-14.6-14.6-4.4-4.3 4.4-4.4 14.6-14.6z"></path></svg>';
    var next = document.createElement('button'); next.type = 'button'; next.className = 'splide__arrow splide__arrow--next'; next.setAttribute('aria-label', 'Next testimonial'); next.innerHTML = '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="m15.5 0.932 4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';
    var pagination = document.createElement('div'); pagination.className = 'splide__pagination';
    function desktop() { return window.matchMedia('(min-width:750px)').matches; }
    function step() { var slide = slides[0]; return Math.max(1, slide.getBoundingClientRect().width + (desktop() ? 40 : 15)); }
    slides.forEach(function (_, index) { var dot = document.createElement('button'); dot.type = 'button'; dot.className = 'splide__pagination__page'; dot.setAttribute('aria-label', 'Go to testimonial ' + (index + 1)); dot.addEventListener('click', function () { list.scrollTo({ left: index * step(), behavior: 'smooth' }); }); pagination.appendChild(dot); });
    controls.appendChild(prev); controls.appendChild(pagination); controls.appendChild(next);
    function sync() { var maxCard = desktop() ? Math.max(0, slides.length - 3) : slides.length - 1; var card = Math.max(0, Math.min(maxCard, Math.round(list.scrollLeft / step()))); Array.prototype.forEach.call(pagination.children, function (dot, i) { dot.classList.toggle('is-active', i === card); }); prev.disabled = card === 0; next.disabled = card >= maxCard; }
    prev.addEventListener('click', function () { list.scrollTo({ left: Math.max(0, list.scrollLeft - step()), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollTo({ left: Math.min(list.scrollWidth, list.scrollLeft + step()), behavior: 'smooth' }); });
    list.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  function preserveNativeTestimonials(root) {
    if (!root || (root.id !== 'splide02' && !root.querySelector('.testimonial-card'))) return false;
    root.classList.add('cedar-native-testimonial');
    if (!document.getElementById('cedar-native-testimonial-css')) {
      var style = document.createElement('style');
      style.id = 'cedar-native-testimonial-css';
      style.textContent = [
        '.cedar-native-testimonial .splide__pagination__page::before{background:#000!important;opacity:.35}',
        '.cedar-native-testimonial .splide__pagination__page.is-active::before{background:#000!important;opacity:1}'
      ].join('');
      document.head.appendChild(style);
    }
    return true;
  }

  function init() {
    // 1) Product reviews need their own scroll container. The source shows three
    // one-card slides; the copied Splide shell otherwise clips the second/third card.
    document.querySelectorAll('.review-items-container .splide').forEach(buildReview);
    document.querySelectorAll('#splide02').forEach(buildTestimonials);

    // 2) Splide testimonial carousels — real slides only, drop pre-baked clones/pagination
    document.querySelectorAll('.splide').forEach(function (root) {
      if (root.closest('.review-items-container')) return;
      if (root.id === 'splide02') return;
      // The community testimonial slider is already hydrated by the theme's
      // Splide runtime. Do not replace its transform carousel with the Cedar
      // native overflow fallback, or arrows, pagination, and touch gestures
      // compete for control of the same list.
      if (preserveNativeTestimonials(root)) return;
      var list = root.querySelector('.splide__list');
      if (!list) return;
      list.querySelectorAll('.splide__slide.is-clone').forEach(function (c) { c.remove(); });
      // kill the broken pre-rendered pagination/arrows so ours are the only ones
      root.querySelectorAll('.splide__pagination').forEach(function (p) { p.remove(); });
      build(list, {
        slides: function (t) { return Array.prototype.slice.call(t.querySelectorAll('.splide__slide')); },
        basis: '100%', max: 'none', active: '#e11d48',
        prev: '.splide__arrow--prev', next: '.splide__arrow--next'
      });
    });

    // 2) Vitals instagram feed ("See it in action") — 3 images in one horizontal strip
    document.querySelectorAll('.Vtl-InstagramFeedLayout__PostList').forEach(function (list) {
      build(list, {
        slides: function (t) { return Array.prototype.slice.call(t.querySelectorAll('.Vtl-InstagramFeedLayout__Post')); },
        basis: '32%', max: '180px', gap: '10px', active: '#e11d48',
        prev: '.Vtl-InstagramFeedLayout__Arrow', next: '.Vtl-InstagramFeedLayout__Arrow'
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // apps can inject late — re-scan a few times
  var n = 0, iv = setInterval(function () { init(); if (++n > 6) clearInterval(iv); }, 800);
})();
